import { useEffect, useState } from "react";
import { getStateDetails } from "../services/configurationServices";

export const useStateMaster = () => {

    const [state, setState] = useState([]);

    const getState = (id) => {
        console.log("GetState", id)
        try {
            getStateDetails(id).then((resp) => {
                if (resp != undefined) {
                    if (resp.Status == "success") {
                        setState(resp.Data)
                    } else {
                        setState([])
                    }
                }
            })
        } catch (error) {
            console.error(error)
        }
    }


    return { state, getState }
}